<div class="navigation-container" [class.only-back]="!showTopNavigation" [ngClass]="textDirection">
  <opac-button *ngIf="showBackButton()" class="navigation-back" type="text" (click)="goBack()">
    <opac-icon slot="start" icon="navigate_back"></opac-icon>
    {{ 'common.back' | translate }}
  </opac-button>

  <div class="item-navigator" *ngIf="showTopNavigation">
    <opac-button
      *ngIf="showPreviousArrow"
      [disabled]="isLoading"
      [attr.aria-label]="'pagination.previousRecord' | translate"
      (click)="goToPreviousRecord()">
      <opac-icon slot="only-icon" icon="navigate_back"></opac-icon>
    </opac-button>

    <span tabindex="0">{{ currentPosition }} {{ 'pagination.of' | translate }} {{ state.total }}</span>

    <opac-button
      *ngIf="showNextArrow"
      [disabled]="isLoading"
      [attr.aria-label]="'pagination.nextRecord' | translate"
      (click)="goToNextRecord()">
      <opac-icon slot="only-icon" icon="navigate_next"></opac-icon>
    </opac-button>
  </div>
</div>
